import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form204Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        hasActiveMilitaryGuardian: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true')
            .nullable(),
        attendingSiblings: z.array(
            z.object({
                id: z.string(),
                firstName: z.string().nonempty(`${t('sef204SiblingFirstName')} is required.`),
                lastName: z.string().nonempty(`${t('sef204SiblingLastName')} is required.`),
                idNumber: z.string().max(6, {message: `${t('sixMax')}`}),
                current: z.coerce
                    .string({message: `${t('sef204SiblingCurrent')} is required.`})
                    .transform(str => str === 'true'),
            }),
        ),
    });
